import { render, staticRenderFns } from "./addApplyFor.vue?vue&type=template&id=1b52d1dc&scoped=true&"
import script from "./addApplyFor.vue?vue&type=script&lang=js&"
export * from "./addApplyFor.vue?vue&type=script&lang=js&"
import style0 from "./addApplyFor.vue?vue&type=style&index=0&id=1b52d1dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b52d1dc",
  null
  
)

export default component.exports